const Color = require("color-js");

const Colors = {
  white: Color("#FFFFFF"),
  black: Color("#000000"),
  orange: Color("#F2923A"),
  lightorange: Color("#FFAB50"),
  lightorange2: Color("#FFD3AB"),
  gray: Color("#98989A"),
  lightgray: Color("#98989A"),
  lightgray2: Color("#D7D7D7"),
  green: Color("#49C82A"),
  blue: Color("#22409B"),
  lightblue: Color("#7995ED"),
};

export default Colors;
